module.exports = __webpack_public_path__ + "media/svg-new/avatar-7 2-140e2152.svg";